import { useMutation, useQuery } from '@apollo/client'
import React, { useState } from 'react'
import { ASSIGN_TICKET } from '../../../graphql/mutation'
import { toast } from 'react-toastify'
import { GET_ALL_SUPPORT_ID, GET_TOTAL_NUMBER_OF_TICKET } from '../../../graphql/query'
import { Loader } from 'react-bootstrap-typeahead'
import { v4 as uuidv4 } from 'uuid'

interface IProps {
  closeModal: any
  assignTicketData: any
  adminTicketData: any
}

const AssignTicketModal: React.FC<IProps> = ({ closeModal, assignTicketData, adminTicketData }) => {
  const [assignTicketName, setAssignTicketName] = useState<any>(null)
  const [error, setError] = useState(false)

  console.log()

  const [assignTicket, { loading: mutationLoading }] = useMutation(ASSIGN_TICKET, {
    refetchQueries: [
      {
        query: GET_TOTAL_NUMBER_OF_TICKET,
        context: {
          headers: {
            'access-control-allow-methods': 'SuperAdmin-Tickets'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'SuperAdmin-Tickets'
      }
    }
  })
  const {
    data: supportData,
    loading: supportLoading,
    error: supportError
  } = useQuery(
    GET_ALL_SUPPORT_ID,

    {
      context: {
        headers: {
          'access-control-allow-methods': 'SuperAdmin-Tickets'
        }
      }
    }
  )

  if (supportLoading) {
    return <>Loading....</>
  }

  if (supportError) {
    console.log(supportError)
  }
  const assignTIcketHandler = async () => {
    if (!assignTicketName) {
      setError(true)

      return
    }
    try {
      const inputData = {
        ticketId: assignTicketData?.id,
        supportEngineerId: +assignTicketName,
        bgAccountId: assignTicketData?.bgAccountId
      }

      const { data } = await assignTicket({
        variables: {
          input: inputData
        }
      })
      await adminTicketData()
      closeModal()
      toast.success(data?.assignTicket?.message)
    } catch (error) {
      console.error('Error editing ticket:', error)
    }
  }

  const handleDropdownChange = (selectedItem: any) => {
    setError(false)
    console.log(selectedItem.target.value, 'SSSSSS')
    setAssignTicketName(selectedItem.target.value)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}
      >
        <h2
          style={{
            padding: '10px',
            marginBottom: '0px',
            paddingLeft: '0px',
            width: '100%',
            textAlign: 'center'
          }}
        >
          Assign Ticket
        </h2>
        <button
          type='button'
          className='btn-close'
          aria-label='Close'
          onClick={closeModal}
        ></button>
      </div>

      <div style={{ display: 'flex', gap: '20px', width: '100%', alignItems: 'center' }}>
        <label
          style={{ width: '15%', fontSize: '16px' }}
          className='form-label fs-6 fw-bolder text-dark d-flex'
        >
          Title
        </label>

        <p
          className='ms-1'
          style={{ backgroundColor: '#f5f8fa', margin: '0', flex: '1', padding: '15px 10px' }}
        >
          {assignTicketData?.title}
        </p>
      </div>
      <div style={{ display: 'flex', gap: '20px', width: '100%', alignItems: 'center' }}>
        <label
          style={{ width: '15%', fontSize: '16px' }}
          className='form-label fs-6 fw-bolder text-dark d-flex'
        >
          Description
        </label>

        <p
          className='ms-1'
          style={{
            backgroundColor: '#f5f8fa',
            margin: '0',
            flex: '1',
            padding: '15px 10px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            width: '200px'
          }}
        >
          {assignTicketData?.description}
        </p>
      </div>

      <div style={{ display: 'flex', width: '100%', alignItems: 'center', gap: '20px' }}>
        <label
          style={{ fontSize: '15px', letterSpacing: '-0.4px', width: '20%' }}
          className='form-label fs-6 fw-bolder text-dark d-flex'
        >
          Agents Name
        </label>

        <select
          required
          onChange={handleDropdownChange}
          value={assignTicketName}
          className=' form-control form-control-lg form-control-solid'
        >
          <option disabled selected>
            Select
          </option>
          {supportData?.getAllSupportEngineers?.length > 0 &&
            supportData?.getAllSupportEngineers?.map((el: any, index: any) => (
              <option key={uuidv4()} value={el?.userId}>
                {el?.name}
              </option>
            ))}
        </select>
      </div>
      {error && (
        <p style={{ width: '100%', textAlign: 'center', color: 'red' }}>This field is required</p>
      )}
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <button
          className='btn btn-primary mt-4 px-4'
          onClick={assignTIcketHandler}
          style={{ width: '30%' }}
        >
          {mutationLoading ? (
            <div>
              Assinging <Loader />
            </div>
          ) : (
            'Assign'
          )}
        </button>
      </div>
    </div>
  )
}

export default AssignTicketModal
